/*
 * Formaty formats your integer to a time
 * @version 1.0.0
 */

function parseSecs(seconds) {
  const roundToZero = seconds <= 0 ? Math.ceil : Math.floor;

  return {
    days: roundToZero(seconds / 86400),
    hours: roundToZero(seconds / 3600) % 24,
    minutes: roundToZero(seconds / 60) % 60,
    seconds: roundToZero(seconds) % 60,
  };
}

function addZero(value) {
  return `${value <= 9 ? "0" : ""}${value}`;
}

export default function formatDuration(sec) {
  let unsignedSeconds = sec < 0 ? -sec : sec;
  let sign = sec <= -1000 ? "-" : "";
  let time = parseSecs(unsignedSeconds);
  let seconds = addZero(time.seconds);
  let minutes = addZero(time.minutes);
  let hours = addZero(time.hours);

  if (time.days) return `${sign}${time.days}:${hours}:${minutes}:${seconds}`;
  if (time.hours) return `${sign}${time.hours}:${minutes}:${seconds}`;
  return `${sign}${time.minutes}:${seconds}`;
}
